export const JOB_MOBILE_PHOTO_ENTITY_NAME= 'JobMobilePhotoAttachment'
export const PHOTO_FORM_PREVIEW_CONST = {
  ELEVATE_PAGE: 'www.elevatelimited.com',
  ELEVATE_EMAIL: 'info@elevatelimited.com',
  CLIENT_NAME_QUES_ID: 172,
  REPORT_NUMBER_QUES_ID: 173,
  FACILITY_NAME_QUES_ID: 2,
  ASSESSMENT_START_DATE_QUES_ID: 176,
  ASSESSMENT_END_DATE_QUES_ID: 177,
};
